"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _languageService = _interopRequireDefault(require("../../language/services/languageService"));

var _Badge = _interopRequireDefault(require("../commons/Badge"));

var _transportOrderStatusesIds = _interopRequireDefault(require("../../consts/transportOrderStatusesIds"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var propTypes = {
  statusId: _propTypes.default.string.isRequired
};
var defaultProps = {};

var TransportStatusLabel = function TransportStatusLabel(_ref) {
  var statusId = _ref.statusId,
      others = _objectWithoutProperties(_ref, ["statusId"]);

  var getBadgeProperties = function getBadgeProperties() {
    switch (statusId) {
      case _transportOrderStatusesIds.default.placed:
        return {
          red: true,
          label: _languageService.default.labels.Exposed()
        };

      case _transportOrderStatusesIds.default.accepted:
        return {
          blue: true,
          label: _languageService.default.labels.AcceptedForRealization()
        };

      case _transportOrderStatusesIds.default.loaded:
        return {
          customGreen: true,
          label: _languageService.default.labels.Loaded()
        };

      case _transportOrderStatusesIds.default.delivered:
        return {
          orange: true,
          label: _languageService.default.labels.Delivered()
        };

      case _transportOrderStatusesIds.default.realized:
        return {
          green: true,
          label: _languageService.default.labels.Completed()
        };

      case _transportOrderStatusesIds.default.canceled:
        return {
          orange: true,
          label: _languageService.default.labels.Canceled()
        };

      default:
        return {
          grey: true,
          label: _languageService.default.labels.TransportOrder()
        };
    }
  };

  return _react.default.createElement(_Badge.default, _extends({}, others, getBadgeProperties(), {
    inverted: true
  }));
};

TransportStatusLabel.propTypes = propTypes;
TransportStatusLabel.defaultProps = defaultProps;

var _default = (0, _react.memo)(TransportStatusLabel);

exports.default = _default;